
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import VueSlickCarousel from 'vue-slick-carousel'
import { INDEX_SET_LOADING, GET_RELATED_COLLECTION } from '../../store/store.const'

export default {
  name: 'RelatedCollection',
  components: {
    VueSlickCarousel
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      collection: [],
      slideSetting: {
        'dots': false,
        'infinite': true,
        'initialSlide': 0,
        'speed': 500,
        'slidesToShow': 2,
        'slidesToScroll': 1,
        'swipeToSlide': false,
        'responsive': [
          {
            'breakpoint': 900,
            'settings': {
              'slidesToShow': 1,
              'slidesToScroll': 1
            }
          },
          {
            'breakpoint': 768,
            'settings': {
              'slidesToShow': 1,
              'slidesToScroll': 1
            }
          },
          {
            'breakpoint': 600,
            'settings': {
              'slidesToShow': 1,
              'slidesToScroll': 1
            }
          }
        ]
      }
    }
  },
  async created() {
    await this.getListCollection()
  },
  mounted() {
  },
  methods: {
    handleClickCollection(id) {
      this.$router.push('/collection/' + id)
    },
    async getListCollection() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const collection = await this.$store.dispatch(GET_RELATED_COLLECTION, this.product.id)
        this.collection = collection.data.data
      } catch (error) {
        console.log(error)
        this.collection = []
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    handleImageError(item) {
      item.image = null
    }
  }
}
